import type { MetricsClient } from '../types/MetricsClient'
import { MetricsLogger } from '../utils/MetricsLogger'
import { createDeduplicationKey } from '../utils/MetricsDeduplication'
import { getRvUserType } from '@strata-monorepo/utils/rvUserType'
import { getMetricsAudience } from '../utils/audienceContext'

export class ConsoleAdapter implements MetricsClient {
  private metricsLogger = MetricsLogger.getInstance()
  private userType = getRvUserType()

  /**
   * Get tags with user type and audience included.
   * @param tags - Optional existing tags
   * @returns Tags merged with user type and audience
   */
  private getTagsWithUserType(
    tags?: Record<string, string | number | boolean>,
  ): Record<string, string | number | boolean> {
    const audience = getMetricsAudience()
    return {
      ...tags,
      userType: this.userType,
      audience,
    }
  }

  increment(name: string, value = 1, tags?: Record<string, string>): void {
    const deduplicationKey = createDeduplicationKey(name, tags)

    if (!this.metricsLogger.shouldLogMetric(deduplicationKey)) {
      return // Skip duplicate
    }

    const tagsWithUserType = this.getTagsWithUserType(tags)
    console.log('increment', `${name}:`, value, { tags: tagsWithUserType })
  }

  gauge(name: string, value: number, tags?: Record<string, string>): void {
    const deduplicationKey = createDeduplicationKey(name, tags)

    if (!this.metricsLogger.shouldLogMetric(deduplicationKey)) {
      return // Skip duplicate
    }

    const tagsWithUserType = this.getTagsWithUserType(tags)
    console.log('gauge', `${name}:`, value, { tags: tagsWithUserType })
  }

  trackEvent(name: string, attributes: Record<string, string | number | boolean>): void {
    const attributesWithUserType = this.getTagsWithUserType(attributes)

    console.log('trackEvent', `${name}:`, { attributes: attributesWithUserType })
  }
}
